export default "__VITE_ASSET__GyvgJ8ud__"